import {
  Flex,
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
} from '@chakra-ui/react';

export default function FormElementForCheckboxes({
  children,
  errorMessage = null,
  isDisabled = null,
  isInvalid = null,
  isRequired = null,
  isInline = null,
  formHelperText = null,
}) {
  return (
    <FormControl
      isDisabled={isDisabled}
      isInvalid={isInvalid}
      isRequired={isRequired}
    >
      <Flex align="center" w="fit-content" position="relative">
        {children}
        <FormLabel position="absolute" right="-1.35rem" top="-2px">
          &nbsp;
        </FormLabel>
      </Flex>
      {isInvalid && (
        <FormErrorMessage width={isInline ? '100%' : null}>
          {errorMessage}
        </FormErrorMessage>
      )}
      {formHelperText && <FormHelperText>{formHelperText}</FormHelperText>}
    </FormControl>
  );
}
